"use client";

import { useRouter } from "next/navigation";

import { NotFoundIllustration } from "@saas/shared/illustration";
import { BaseButton } from "@saas/shared/ui/base-button/base-button";

export default function Custom404() {
  const router = useRouter();

  const handleBack = () => {
    router.push("/");
  };

  return (
    <div className={"grid h-[calc(100vh-120px)] place-content-center"}>
      <div className={"grid w-[320px] justify-items-center gap-4"}>
        <div>
          <NotFoundIllustration width={192} height={128} />
        </div>
        <div className={"text-center"}>
          <p className={"title-large md:headline-h2 text-he"}>
            Halaman tidak ditemukan.
          </p>
          <p className={"body-b2 md:body-b1 text-he"}>
            Maaf, sepertinya halaman yang Anda cari sudah dihapus atau tidak
            tersedia.
          </p>
        </div>
        <BaseButton variant={"primary"} size={"big"} onClick={handleBack}>
          Kembali Ke Beranda
        </BaseButton>
      </div>
    </div>
  );
}
